exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1vmylufkXAJYgG3U5wCah0 {\n  color: #9f9f9f;\n}\n", ""]);

// exports
exports.locals = {
	"placeholder": "_1vmylufkXAJYgG3U5wCah0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/Common/FormMUIWrapperComponents/CustomSingleSelect/CustomSingleSelect.css
// module id = 9755
// module chunks = 23